import * as React from 'react';

function SvgRoute(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M5 1.64l4.68 4.33-1.36 1.47L6 5.3v10.69c0 1.17 1.01 2.15 2.33 2.23h.17c1.34 0 2.4-.93 2.5-2.08V8.56c0-2.36 2.03-4.24 4.5-4.24A4.4 4.4 0 0120 8.35v10.07l2.32-2.15 1.36 1.46L19 22.07l-4.68-4.34 1.36-1.46L18 18.42V8.56c0-1.22-1.1-2.24-2.5-2.24-1.34 0-2.4.94-2.5 2.09v7.57c0 2.36-2.03 4.24-4.5 4.24A4.4 4.4 0 014 16.18V5.3L1.68 7.44.32 5.97 5 1.64z" />
    </svg>
  );
}

export default SvgRoute;
